import {CsvConfigJsonResult} from '../synoptic-configuration-csv-types';

export function isClosePopupArgs(obj: any): CsvConfigJsonResult {
  let valid = true;
  let errors = [];
  if(typeof obj !== 'object' || Object.keys(obj).length > 0){
    valid = false;
    errors.push({code:'mustBeEmptyObject', key: 'args', value: obj})
  }
  return {result: valid, errors: errors};
}
